import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErrorContainerComponent, AccessDeniedComponent, PageNotFoundComponent } from '@content-platform/web-angular-shared-util-error-handling';
import { OktaWrapGuard } from '@content-platform/web-angular-shared-data-access-okta-auth2';
import { OktaCallbackComponent } from '@okta/okta-angular';
import * as i0 from "@angular/core";
const routes = [
    {
        path: '',
        canActivate: [OktaWrapGuard],
        canActivateChild: [OktaWrapGuard],
        loadChildren: () => import('@mip2/main').then((module) => module.WebAngularMip2MainModule),
        ...(typeof ngServerMode !== "undefined" && ngServerMode ? { ɵentryName: "../../libs/web/angular/mip2/main/src/index.ts" } : {})
    },
    { path: 'login/callback', component: OktaCallbackComponent },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: 'error',
        component: ErrorContainerComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        component: PageNotFoundComponent
    }
];
export class AppRoutingModule {
    static { this.ɵfac = function AppRoutingModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppRoutingModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppRoutingModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [RouterModule.forRoot(routes, {
                initialNavigation: 'enabledBlocking'
            }), RouterModule] }); }
}
//# sourceMappingURL=app-routing.module.js.map